import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL,
  timeout: 60000,
  headers: {},
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.withCredentials = true;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return response;
    }
    if (response?.data?.code === 200) {
      return response;
    }
    return Promise.reject(response?.data?.data);
  },
  (error) => {
    if (error?.response?.status === 403) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
